export default "__VITE_ASSET__BKxnvxwO__"